import React from "react";
import { Text, TouchableOpacity, View } from "react-native";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextInput from "./../../components/TextField/TextField";
import { enUS } from "./en-US.js";
import { zhHK } from "./zh-HK.js";
import { Checkbox, FormControlLabel } from "@material-ui/core";
import { Button, TickCheckbox } from "./../../Form";
import { languageStorage } from "../../lib/LanguageStorage.js";

const otpDv = {
  optCode: "",
  isSaveDevice: false,
};

export const SEND_LIMIT_TIME = 60;

class ModalOTP extends React.Component {
  constructor(props) {
    super(props);
    this.state = { ...otpDv, diffSecond: undefined };
    this.timer = null;
  }
  componentDidMount() {
    const getText = (language) => {
      let text = enUS;
      if (language == "zhHK") {
        text = zhHK;
      }
      return text;
    };
    languageStorage.getLanguage((language) =>
      this.setState({
        language: language,
        text: getText(language),
      })
    );
  }

  updateDiff = () => {
    const { shortMessageTimestamp } = this.state;
    if (!shortMessageTimestamp) {
      return;
    }
    const now = Date.now();
    const diffSecond = Math.floor((now - shortMessageTimestamp) / 1000);
    this.setState({ diffSecond });
  };

  componentDidUpdate(prevProps) {
    if (prevProps.open !== this.props.open) {
      if (this.props.open) {
        this.setState(otpDv);
      }

      // handle 30S timer
      if (this.props.open) {
        this.setState({ shortMessageTimestamp: Date.now() });
        this.timer = setInterval(this.updateDiff, 1000);
      } else {
        clearInterval(this.timer);
      }
    }
  }

  async _onClick(bool) {
    this.setState({ isLoading: true });
    const res = await this.props.onResend(bool);
    if (res?.msgCode === 0) {
      this.setState({ shortMessageTimestamp: Date.now()});
    }
    this.setState({ isLoading: false });
  }

  render() {
    const { open, onClose, onSubmit, onResend, canSave } = this.props;
    const tooFastSend = !this.state.diffSecond ? false : SEND_LIMIT_TIME > this.state.diffSecond;
    return (
      <Dialog open={open} maxWidth={"sm"} fullWidth>
        <DialogTitle id="alert-dialog-title">
          {this.state.text?.multiFactorAuth}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Text style={{ textAlign: "left" }}>
              {this.props.onlyEmail ? this.state.text?.enterEmailOTP : this.props.onlySMS ? this.state.text?.enterSMSOTP : this.state.text?.enterOTP}
            </Text>
            <View style={{ marginTop: "10px" }}>
              <TextInput
                style={{}}
                onChangeText={(text) => this.setState({ optCode: text })}
                value={this.state.optCode}
                keyboardType="number"
                placeholder={this.state.text?.otp}
                isOTP={true}
              />
            </View>
            {onResend && (
              <>
                {!this.props.onlyEmail && <div>
                  <Button
                    variant="text"
                    onPress={() => this._onClick(false)}
                    sx={{
                      alignItems: "flex-start",
                      marginTop: 10,
                      marginBottom: 10,
                      paddingLeft: 0,
                      paddingRight: 0,
                      display: "inline-block",
                      height: "auto",
                    }}
                    textSx={{ fontSize: "16px" }}
                    disabled={this.state.isLoading || tooFastSend}
                    disabledText={
                      this.state.isLoading
                        ? undefined
                        : `${this.state.text?.resendOTPSMS} (${
                            SEND_LIMIT_TIME - this.state.diffSecond
                          }${this.state.text?.second})`
                    }
                  >
                    {this.state.text?.resendOTPSMS}
                  </Button>
                </div>}
                {!this.props.onlySMS && <div>
                  <Button
                    variant="text"
                    onPress={() => this._onClick(true)}
                    sx={{
                      alignItems: "flex-start",
                      marginTop: 0,
                      marginBottom: 10,
                      paddingLeft: 0,
                      paddingRight: 0,
                      display: "inline-block",
                      height: "auto",
                    }}
                    textSx={{ fontSize: "16px" }}
                    disabled={this.state.isLoading || tooFastSend}
                    disabledText={
                      this.state.isLoading
                        ? undefined
                        : `${this.state.text?.resendOTPEmail} (${
                            SEND_LIMIT_TIME - this.state.diffSecond
                          }${this.state.text?.second})`
                    }
                  >
                    {this.state.text?.resendOTPEmail}
                  </Button>
                </div>}
              </>
            )}
            {canSave && (
              <View>
                <TickCheckbox
                  checked={this.state.isSaveDevice}
                  onChange={(event) => {
                    this.setState({
                      isSaveDevice: event.target.checked,
                    });
                  }}
                  label={this.state.text?.rememberDevice}
                />
              </View>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onPress={() => {
              onSubmit(this.state.optCode, this.state.isSaveDevice);
              onClose();
            }}
          >
            {this.state.text?.submit}
          </Button>
          <Button
            variant="text"
            withMargin
            onPress={() => {
              onClose();
            }}
          >
            {this.state.text?.cancel}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default ModalOTP;
